"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Ключ, по которому в Cookie's хранится значение.
 */
var CookieKey;
(function (CookieKey) {
    /**
     * Идентификатор сессии.
     */
    CookieKey["SESSION_ID"] = "dvmclcks";
    /**
     * Уникальный идентификатор устройства.
     */
    CookieKey["DEVICE_ID"] = "dvmclckf";
    /**
     * Уникальный идентификатор визита пользователя на сайт.
     */
    CookieKey["VISIT_ID"] = "dvmclckv";
})(CookieKey || (CookieKey = {}));
exports.default = CookieKey;
